var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"newrow_l",staticStyle:{"padding":"6px"},on:{"click":function($event){return _vm.click($event)}}},[_vm._v(" "+_vm._s(_vm.newRowText)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }